export const name = 'gzMouseWheelUp';

/**
 * @ngdoc directive
 * @name gazelle.components.mouse.wheelUp.directive:gzMouseWheelUp
 *
 * @description
 * `<gz-mouse-wheel-up>` captures wheel down events.
 *
 * @usage
 * ```html
 * <div gz-mouse-wheel-up='vm.wheelUp()'>
 *
 * ```
 */
export default function gzMouseWheelUp($compile,$window) {
  //noinspection BadExpressionStatementJS
  'ngInject';


  var directive = {
    restrict: 'EA',
    link: gzMouseUpLink,
  };

  return directive;

  //////////////////////
  // Private functions
  function gzMouseUpLink(scope, element, attrs) {
    element.bind('DOMMouseScroll mousewheel onmousewheel', (ev) => {
      let prevent = false;
      if (attrs.gzMouseWheelPrevent) {
        prevent = scope.$eval(attrs.gzMouseWheelPrevent);
      }

      if (!prevent) {
        let event = $window.event || ev;
        let delta = Math.max(-1, Math.min(1, (event.wheelDelta || -event.detail)));
        if (delta > 0) {
          scope.$apply(() => {
            scope.$eval(attrs.gzMouseWheelUp);
          });
        }

        if (event.preventDefault) {
          event.preventDefault();
        }

        // for IE
        event.returnValue = false;
      }
    });
  }
}



// WEBPACK FOOTER //
// ../~/@printos/gazelle/src/components/mouse-wheel/wheel-up/wheel-up.directive.js